import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { SocialProofSection } from './SocialProofSection';
import { EmotionalOpening } from './EmotionalOpening';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { WhatsIncluded } from './WhatsIncluded';
import { BeforeAfter } from './BeforeAfter';
import { BonusesSection } from './BonusesSection';
import { LaunchUrgency } from './LaunchUrgency';
import { OfferStack } from './OfferStack';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
// Lazy-load PurchaseNotification to defer framer-motion bundle (~47 KiB savings)
const PurchaseNotification = lazy(() => import('./PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
export function SalesPage() {
  useEffect(() => {
    // Preload LCP hero image for faster discovery
    const preloadHero = document.createElement('link');
    preloadHero.rel = 'preload';
    preloadHero.as = 'image';
    preloadHero.href = 'https://cdn.magicpatterns.com/uploads/oMwr1o2GGfg6HJQmfMrzfj/ChatGPT_Image_Apr_11,_2026,_03_17_01_PM_-_Edited.png';
    document.head.appendChild(preloadHero);
    // Defer Meta Pixel — load after page is idle to avoid blocking
    const initPixel = () => {
      if (!(window as any).fbq) {
        const n: any = (window as any).fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!(window as any)._fbq) (window as any)._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        t.onload = () => {
          ;
          (window as any).fbq('init', '1538074310626033');
          (window as any).fbq('track', 'PageView');
        };
        document.head.appendChild(t);
        const noscriptImg = document.createElement('img');
        noscriptImg.height = 1;
        noscriptImg.width = 1;
        noscriptImg.style.display = 'none';
        noscriptImg.src = 'https://www.facebook.com/tr?id=1538074310626033&ev=PageView&noscript=1';
        document.body.appendChild(noscriptImg);
      }
      if ((window as any).fbq && (window as any).fbq.loaded) {
        ;
        (window as any).fbq('init', '1538074310626033');
        (window as any).fbq('track', 'PageView');
      }
    };
    // Use requestIdleCallback to defer pixel loading, fallback to setTimeout
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(initPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(initPixel, 2000);
    }
  }, []);
  return <div className="min-h-screen w-full bg-warm-light selection:bg-orange selection:text-white" data-id="element-304">
      {/* Section 2 — Hero */}
      <HeroSection data-id="element-305" />

      {/* Section 2.5 — Social Proof & Problem Awareness */}
      <SocialProofSection data-id="element-306" />

      {/* Section 3 — Emotional Problem */}
      <EmotionalOpening data-id="element-307" />

      {/* Section 4 — Problem List */}
      <ProblemSection data-id="element-308" />

      {/* Section 5 — Solution */}
      <SolutionSection data-id="element-309" />

      {/* Section 6 — What's Inside */}
      <WhatsIncluded data-id="element-310" />

      {/* Section 7 — Before / After */}
      <BeforeAfter data-id="element-311" />

      {/* Section 8 — Bonuses */}
      <BonusesSection data-id="element-312" />

      {/* Section 8.5 — Launch Urgency */}
      <LaunchUrgency data-id="element-313" />

      {/* Section 9 — Offer */}
      <OfferStack data-id="element-314" />

      {/* Section 10 — Guarantee */}
      <GuaranteeSection data-id="element-315" />

      {/* Section 11 — Testimonials */}
      <TestimonialsSection data-id="element-316" />

      {/* Section 12 — FAQ */}
      <FAQSection data-id="element-317" />

      {/* Section 13 — Final Close */}
      <FinalCTA data-id="element-318" />

      {/* Footer */}
      <FooterSection data-id="element-319" />

      {/* Lazy-loaded notification popup (defers framer-motion) */}
      <Suspense fallback={null} data-id="element-320">
        <PurchaseNotification data-id="element-321" />
      </Suspense>
    </div>;
}